import {
  AddressModal,
  AddressSuggestionsModal,
  CommercialAddressModal,
} from 'components';
import { useIsZipOnlyAddress } from 'hooks';

export function ShopWrapper({ children }) {
  const isZipOnlyAddress = useIsZipOnlyAddress();

  if (isZipOnlyAddress) {
    return <>{children}</>;
  }

  return (
    <>
      {children}
      <AddressModal />
      <AddressSuggestionsModal />
      <CommercialAddressModal />
    </>
  );
}
